<template>
    <van-popup v-model="showAuthenticationMethod"
        position="bottom"
        :closeable="false"
        :close-on-click-overlay="false"
        class="authentication-methods">
        <div class="authentication-title">
            <span>请选择认证方式</span>
            <img src="static/image/closeIcon.png"
                alt=""
                @click="close()">
        </div>
        <div class="authentication-content">
            <!-- 微信学生认证 -->
            <div v-if="isWeChatStudent && loginType === LoginType.Wechat"
                class="detail">
                <div class="detail-title">微信学生认证</div>
                <div class="detail-rule">
                    <div>1、补充学生身份信息</div>
                    <div>2、完成人脸识别认证</div>
                    <div>3、成为荣耀认证用户享受特殊优惠</div>
                </div>
                <div class="detail-btn"
                    @click="toVerify(IdentityVerify.weChatSchool)">我是学生</div>
            </div>
            <!-- 芝麻教师学生医护认证 -->
            <div v-if="isSesame && loginType === LoginType.Alipay"
                class="detail">
                <div class="detail-title">芝麻工作证认证</div>
                <div class="detail-rule">
                    <div>1、授权芝麻工作证</div>
                    <div>{{ sesameTip() }}</div>
                    <div>3、成为荣耀认证用户享受特殊优惠</div>
                </div>
                <div class="detail-btn-parent">
                    <div v-if="identityTypeList.length > 0 && identityTypeList.includes(IdentityVerify.teacher)"
                        class="detail-btn"
                        @click="toVerify(IdentityVerify.teacher)">我是教师</div>
                    <div v-if="identityTypeList.length > 0 && identityTypeList.includes(IdentityVerify.medicalWorkers)"
                        class="detail-btn"
                        @click="toVerify(IdentityVerify.medicalWorkers)">我是医护</div>
                    <div v-if="identityTypeList.length > 0 && identityTypeList.includes(IdentityVerify.student)"
                        class="detail-btn"
                        @click="toVerify(IdentityVerify.student)">我是学生</div>
                </div>
            </div>
            <!-- 支付宝学生认证 -->
            <div v-if="isAlipayStudent && loginType === LoginType.Alipay"
                class="detail">
                <div class="detail-title">支付宝学生认证</div>
                <div class="detail-rule">
                    <div>1、补充学生身份信息</div>
                    <div>2、成为荣耀认证用户享受特殊优惠</div>
                </div>
                <div class="detail-btn"
                    @click="toVerify(IdentityVerify.alipayStudent)">我是学生</div>
            </div>
            <!-- 芝麻信用 -->
            <div v-if="isAlipayCredit && loginType === LoginType.Alipay"
                class="detail">
                <div class="detail-title">芝麻信用授权</div>
                <div class="detail-rule">
                    <div>授权芝麻信用，成为荣耀认证用户享受特殊优惠</div>
                </div>
                <div class="detail-btn long-detail-btn"
                    @click="toVerify(IdentityVerify.zhiMaCredit)">授权芝麻信用</div>
            </div>
            <!-- edu教育认证 -->
            <div v-if="isEduEmail"
                class="detail">
                <div class="detail-title">EDU教育认证</div>
                <div class="detail-rule">
                    <div>1、绑定EDU邮箱并发送验证码</div>
                    <div>2、打开邮箱查看验证码</div>
                    <div>3、回到小程序输入验证码</div>
                    <div>4、成为荣耀认证用户享受特殊优惠</div>
                </div>
                <div class="detail-btn long-detail-btn"
                    @click="toVerify(IdentityVerify.eduEducation)">EDU邮箱认证</div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { IdentityVerify, CouponType, LoginType } from '../../../../commons/commonVariables.js';
import { Toast } from 'vant';
export default {
  props: {
    identityTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    checkChannel: {
      type: Number,
      default: null,
    },
    elementParentObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    clickElementObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    clickIndex: {
      type: Number,
      default: null,
    },
    handleReceivecoupon: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    receiveAward: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    receiveEquityPackage: {
      type: Function,
      default: () => {
        return () => {};
      },
    },
    loginType: {
      type: String,
      default: '',
    },
    checkResultList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      IdentityVerify,
      LoginType,
      CouponType,
      showAuthenticationMethod: false,
    };
  },
  computed: {
    isWeChatStudent() {
      if (this.identityTypeList.length > 0 && this.identityTypeList.includes(IdentityVerify.weChatSchool)) {
        return true;
      }
      return false;
    },
    isSesame() {
      if (this.identityTypeList.length > 0) {
        return [IdentityVerify.student, IdentityVerify.teacher, IdentityVerify.medicalWorkers].some((item) => {
          return this.identityTypeList.includes(item);
        });
      }
    },
    isEduEmail() {
      if (this.identityTypeList.length > 0 && this.identityTypeList.includes(IdentityVerify.eduEducation)) {
        return true;
      }
      return false;
    },
    isAlipayStudent() {
      if (this.identityTypeList.length > 0 && this.identityTypeList.includes(IdentityVerify.alipayStudent)) {
        return true;
      }
      return false;
    },
    isAlipayCredit() {
      if (this.identityTypeList.length > 0 && this.identityTypeList.includes(IdentityVerify.zhiMaCredit)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    show() {
      this.showAuthenticationMethod = true;
    },
    close() {
      this.showAuthenticationMethod = false;
      this.$emit('close');
    },
    sesameTip() {
      //2、完成学生/医护/教师认证
      const curSesameType = [];
      this.identityTypeList.forEach((item) => {
        if ([IdentityVerify.student, IdentityVerify.teacher, IdentityVerify.medicalWorkers].includes(item)) {
          curSesameType.push(this.getSesameName(item));
        }
      });
      let curSesameTypeStr = curSesameType.length ? curSesameType.join('/') : '';
      return `2、完成${curSesameTypeStr}认证`;
    },
    getSesameName(type) {
      let name = '';
      switch (type) {
        case IdentityVerify.student:
          name = '学生';
          break;
        case IdentityVerify.teacher:
          name = '教师';
          break;
        case IdentityVerify.medicalWorkers:
          name = '医护';
          break;
        default:
          name = '';
      }
      return name;
    },
    checkCodeBeforeRequest(type) {
      // 芝麻信用-1501未授权，直接跳转对应的授权流程，无需再次请求 identity/checkOne 接口
      // （1501未授权结果为领取接口 projectActivity/activityProjectReceiveAward 返回code）
      if (type === IdentityVerify.zhiMaCredit) {
        const result =
          (this.checkResultList &&
            this.checkResultList.find((item) => {
              return item.identityBean && item.identityBean.identityType === type;
            })) ||
          {};
        if (result && result.code === 1501) {
          this.$emit('toVerify', type);
          this.close();
          return true;
        }
      }
      return false;
    },
    toVerify(type) {
      if (this.checkCodeBeforeRequest(type)) {
        return;
      }
      // 其他场景请求 identity/checkOne 接口
      let params = {
        identityType: type, //身份限制类型
        checkChannel: this.checkChannel, //0活动、1券、2权益品、3权益包
      };
      if(type === IdentityVerify.zhiMaCredit) {
        params['businessCode']  = this.clickElementObj && this.clickElementObj.id || '';
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `identity/checkOne`,
        params: params,
        success: (r) => {
          if (r && r.code === 200) {
            // 优惠券
            if (this.elementParentObj.pageType === CouponType.coupon) {
              this.handleReceivecoupon(this.clickElementObj, this.elementParentObj, this.clickIndex);
            }
            // 代金券、权益品
            if (this.clickElementObj.pageType === CouponType.voucher || this.clickElementObj.pageType === CouponType.exchangegoods) {
              this.receiveAward(this.clickElementObj, this.clickIndex);
            }
            // 权益包
            if (this.clickElementObj.pageType === CouponType.EQUITY_PACKAGE) {
              this.receiveEquityPackage(this.clickElementObj, this.clickIndex);
            }
            this.close();
          } else if (r && r.code === 1501) {
            // 需要去验证
            this.$emit('toVerify', type);
            if (type !== IdentityVerify.eduEducation) {
              this.close();
            }
          } else if (r && r.code === 1502) {
            // 提示3分钟后重新验证
            // 每19个字符一行，超出换行展示
            const message = this.toHtmlString(r.message || '');
            Toast({
              type: 'html',
              message: `<div style='text-align:center;'>${message}</div>`
            });
          } else {
            // 1503:验证中 500:其他提示
            Toast(r.message);
          }
        },
      });
    },
    toHtmlString(str) {
      const result = [];
      for (let i = 0; i < str.length; i += 19) {
        result.push(str.substring(i, i + 19));
      }
      return result.join('<br>');
    }
  },
};
</script>

<style scoped lang="scss">
.authentication-methods {
  position: absolute;
  bottom: 0;
  width: 100vw;
  border-radius: 8px 8px 0 0;
  background-color: #fff;
  color: #000;
  padding: 0 15px 15px;
  .authentication-title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 52px;
    font-size: 18px;
    margin-bottom: 4px;
    img {
      position: absolute;
      right: 0;
      width: 12px;
      height: 12px;
    }
  }
  .authentication-content {
    max-height: 75vh;
    overflow: scroll;
    scrollbar-width: none; /* Firefox 隐藏滚动条 */
    -ms-overflow-style: none;  /* IE 10+ 隐藏滚动条 */
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari 和 Opera 隐藏滚动条 */
    }
  }
  .detail {
    background-color: #f2f3f5;
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 17px 13px 15px 20px;
    .detail-title {
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .detail-rule {
      font-size: 14px;
    }
    .detail-btn-parent {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
    .detail-btn {
      float: right;
      width: 100px;
      height: 32px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      line-height: 32px;
      background-color: #256fff;
      border-radius: 24px;
      margin-left: 6px;
      margin-top: 15px;
    }
    .long-detail-btn {
      width: 120px;
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/selectMethods.vue